export enum WorkflowStepState {
  None = 'None',
  Wait = 'InProgess',
  CompleteSuccess = 'CompleteSuccess',
  CompleteFailure = 'CompleteFailure',
}
